// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { Brand } from './brand';
import { Category } from './category';
import { Country } from './country';
import { Customer } from './customer';
import { EquipmentAttachment } from './equipment-attachment';
import { EquipmentImage } from './equipment-image';
import { EquipmentModel } from './equipment-model';
import { EquipmentStatus } from './equipment-status';
import { Supplier } from './supplier';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class Equipment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  equipmentId: number;
  applicationUserId: string;
  brandId: number;
  categoryId: number;
  countryId: number;
  createdOn: Date;
  customerId: number;
  description: string;
  eqiupmentName: string;
  equipmentModelId: number;
  equipmentStatusId: number;
  exchangeRate: number;
  modifiedOn: Date;
  purchasingPrice: number;
  salesPrice: number;
  supplierId: number;
  totalExpense: number;
  weight: number;
  workingHours: number;
  yearMake: number;
  applicationUser: ApplicationUser;
  brand: Brand;
  category: Category;
  country: Country;
  customer: Customer;
  equipmentAttachments: EquipmentAttachment[];
  equipmentImages: EquipmentImage[];
  equipmentModel: EquipmentModel;
  equipmentStatus: EquipmentStatus;
  supplier: Supplier;
}

